module.exports = __webpack_public_path__ + "img/process-2.4e283e1a.png";